// libraries
import styled from 'styled-components';

export const StyledHistoryTable = styled.div`
  margin-top: 32px;

  .sht-wrapper {
    &-search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;

      &-left {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      &-right {
        display: flex;
        align-items: center;
        gap: 12px;
      }
    }

    &-table {
      > div {
        min-width: 100%;

        .MuiPaper-root {
          max-height: 100% !important;
          box-shadow: none !important;
        }
      }
    }
  }

  .history-preview {
    width: 60px;
    height: 40px;
    border-radius: 4px;
    object-fit: cover;
  }

  .history-preview-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 40px;
    margin: 0 auto;
    border-radius: 4px;
    background: var(--color-off-white);
    border: 0.5px solid var(--color-pale-gray);
    font-size: 11px;
    color: var(--color-text-gray);
  }

  .history-detail-view-buttons {
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  .history-selected-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    background: var(--color-primary-light, #e8f0fe);
    color: var(--color-primary, #1a73e8);
    font-size: 12px;
    font-weight: 600;
  }
`;
